import React from "react";
import { Tr, Td, Tooltip, IconButton, Text } from "@chakra-ui/react";
import { DeleteIcon, EditIcon, CheckCircleIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { SHARED_ROUTES } from "../../config/routes";
import { deleteStudent } from "../../features/students/studentSlice";


import "./StudentItem.css";
import { useDispatch, useSelector } from "react-redux";

const BooleanIcon = ({ isTrue }) => {
  return isTrue ? <CheckCircleIcon w={4} h={4} color="green.200" /> : <>-</>;
};


const formatPhoneNumber = (number = '') => {
  const match = number.replace(/\D/g, '').match(/^(353|0)(1|\d{2})(\d{3})(\d{3,4})$/);
  if (match) {
    return match[1] === '353'
      ? `+${match[1]} ${match[2]} ${match[3]} ${match[4]}`
      : `${match[1]}${match[2]} ${match[3]} ${match[4]}`;
  };
  return number;
}

const StudentItem = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(
    (state) => state.auth
  );
  const onDelete = () => {
    if (window.confirm("Are you sure you want to delete?")) {
      // Initiate the delete action
      dispatch(deleteStudent({ id: props.id }))
        .catch((error) => {
          console.error("Delete student dispatch error:", error);
        });
    }
  };


  const handleEditStudent = () => {
    navigate(SHARED_ROUTES.editStudent, {
      state: {
        id: props.id,
        name: props.name,
        email: props.email,
        school_name: props.school_name,
        gender_name: props.gender_name,
        week: props.week,
        office: props.office,
        reconfirm_status: props.reconfirm_status,
        guardian_name: props.guardian_name,
        emergency_contact_number: props.emergency_contact_number,
        medical_conditions: props.medical_conditions,
        is_allowed_leave_during_lunch: props.is_allowed_leave_during_lunch,
        is_consent_granted: props.is_consent_granted,
        is_allowed_photo_during_training: props.is_allowed_photo_during_training,
        notes: props.notes,
        ty_info_source: props.ty_info_source,
      },
    });
  };

  const DeleteButton = () => {

    // Debugging
    // console.log("props.week: " + props.week);
    // console.log("User role: " + user.role);
    // console.log("props.flag_for_delete: " + props.flag_for_delete); 

    const isDateInThePast = new Date(props.week) < new Date();
    const isFlagDelete = props.flag_for_delete === 0;

    if (isDateInThePast || isFlagDelete) {
      return (
        <Tooltip
          label={isDateInThePast ? 'You cannot delete a past booking' : 'You cannot delete 5 days before booking'}
          placement="top-end"
          colorScheme="red"
        >
          <IconButton
            as="span"
            aria-label="Delete disabled"
            icon={<DeleteIcon />}
            variant="ghost"
            colorScheme="grey"
          />
        </Tooltip>
      );
    }
    return (
      <IconButton
        aria-label="Delete"
        icon={<DeleteIcon />}
        variant="ghost"
        colorScheme="red"
        onClick={onDelete}
      />
    );
  }

  const EditButton = () => {
    const isDateInThePast = new Date(props.week) < new Date();
    const isFlagEdit = props.flag_for_edit === 0;

    if (isDateInThePast || isFlagEdit) {
      return (
        <Tooltip
          label={isDateInThePast ? 'You cannot edit a past booking' : 'You cannot edit 5 days before booking'}
          placement="top-end"
          colorScheme="red"
        >
          <IconButton
            as="span"
            aria-label="Edit disabled"
            icon={<EditIcon />}
            variant="ghost"
            colorScheme="grey"
          />
        </Tooltip>
      );
    }
    return (
      <IconButton
        aria-label="Edit"
        icon={<EditIcon />}
        variant="ghost"
        colorScheme="red"
        onClick={handleEditStudent}
      />
    );
  }

  return (
    <Tr className="student-item">
      <Td>
        {props.name}
        <br />
        <Text fontSize="0.9em" opacity="0.8" mt="3px" lineHeight="1.2" >
          {props.email}
        </Text>
      </Td>
      <Td>{props.school_name}</Td>
      <Td>{props.gender_name ? props.gender_name : ''}</Td>
      {!props.shouldOmitWeekDetails && <Td>{props.week}</Td>}
      {!props.shouldOmitWeekDetails && <Td>{props.office}</Td>}
      {/* <td>{props.reconfirm_status}</td> */}
      <Td>
        {props.guardian_name}
        <br />
        <Text fontSize="0.9em" opacity="0.8" mt="3px" lineHeight="1.2" whiteSpace="nowrap" >
          {formatPhoneNumber(props.emergency_contact_number)}
        </Text>
      </Td>
      <Td>{props.medical_conditions}</Td>
      <Td><BooleanIcon isTrue={props.is_allowed_leave_during_lunch} /></Td>
      <Td><BooleanIcon isTrue={props.is_consent_granted} /></Td>
      <Td><BooleanIcon isTrue={props.is_allowed_photo_during_training} /></Td>
      {!props.shouldOmitSource && <Td>{props.ty_info_source || 'No data'}</Td>}
      <Td whiteSpace="nowrap">
        {!user.role ? <EditButton /> :
          <IconButton aria-label="Edit" icon={<EditIcon />} variant="ghost" onClick={handleEditStudent} mr="0.3em" />}
        <DeleteButton />
      </Td>
    </Tr>
  );
};

export default StudentItem;
